import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { DefaultLayoutComponent } from './_default_layout';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { MetaModule, MetaLoader, MetaStaticLoader, PageTitlePositioning } from '@ngx-meta/core';
import { ExternalLink } from './_directives/externalLink.directive';
import { MainService } from './_services/_base_services/main.service';
import { ErrorHandleService } from './_services/_base_services/error-Handle.service';
import { ToastrService } from './_services/toastr.service';
import { AppGlobalErrorHandler } from './app-global-errorHandler';
import { GlobalService } from './_services/global.service';

import {SidebarModule} from 'primeng/sidebar';
import { SocialYatay01Module } from './_digi_modules/social-yatay-01/social-yatay-01.module';
import { NotFoundComponent } from './_standart_pages/not-found/not-found.component';
import { GizlilikComponent } from './_standart_pages/gizlilik/gizlilik.component';
import { PrivacyPolicyComponent } from './_standart_pages/privacy-policy/privacy-policy.component';
import { KvkkComponent } from './_standart_pages/kvkk/kvkk.component';

export function metaFactory(): MetaLoader {
  return new MetaStaticLoader({
    pageTitlePositioning: PageTitlePositioning.PrependPageTitle,
    pageTitleSeparator: ' | ',
    applicationName: 'Tv264',
    defaults: {
      title: "Tv264 · Sakarya'nın ilk uydu televizyon kanalı",
      description: "Sakarya'yı dünya izleyecek · Sakarya'nın Tv Kanalı",
      'og:image': 'http://digisoft.com.tr/assets/images/logo-white.png', // Home page logo
      'og:type': 'website',
      'og:locale': 'TR',
    }
  });
}


const APP_CONTAINERS = [
  DefaultLayoutComponent
];

@NgModule({
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ExternalLink,
    NotFoundComponent,
    GizlilikComponent,
    PrivacyPolicyComponent,
    KvkkComponent
  ],
  imports: [
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,

    BrowserModule.withServerTransition({ appId: 'digisoftssr' }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),

    MetaModule.forRoot({
      provide: MetaLoader,
      useFactory: (metaFactory),
      deps: [HttpClient]
    }),

    // webUsage
    SidebarModule,
    SocialYatay01Module

    
  ],
  providers: [
    MainService,
    ErrorHandleService,
    ToastrService,
    { provide: ErrorHandler, useClass: AppGlobalErrorHandler },
    GlobalService,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
